
// Arguments: (Directory, useSubdirectories, RegExp)
const images = require.context('../', false, /logo_cd\d+\.svg$/);
const imageList = images.keys().map(images);


const IconList = ({ }) => {
  
  return (
    <>
       <div className="categories-container col-md-6 offset-md-3">
    {imageList.map((src, index) => (
      <div key={index} className="lp-cat-card category-card">
        <img src={src} alt="icon" height={85} width={85} />
      </div>
    ))}
  </div>
    </>
  );
}

export default IconList;
